// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Y1t","option":"styles_option__3F7EV","active":"styles_active__1MjyY"};